var map = {
	"./Fiat.png": 127,
	"./Hundai.png": 28,
	"./Kia.png": 810,
	"./Nissan.png": 497,
	"./Renault.png": 885,
	"./Volkswagen.png": 719,
	"./chevrolet.png": 91,
	"./datsun.png": 344,
	"./ford.png": 216,
	"./honda.png": 909,
	"./isuzu.png": 750,
	"./mahindra.png": 194,
	"./marutiSuzuki.png": 488,
	"./skoda.png": 283,
	"./tata.png": 569,
	"./toyota.png": 198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 793;